import { useEffect, useRef } from "react";
import { cn } from "../lib/cn";
import type { Sentence } from "../lib/pdf";

export function Reader({
  title,
  sentences,
  activeIndex,
  onSeek,
}: {
  title: string;
  sentences: Sentence[];
  activeIndex: number;
  onSeek: (index: number) => void;
}) {
  const activeRef = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [activeIndex]);

  const paragraphs: Sentence[][] = [];
  let current: Sentence[] = [];
  for (let i = 0; i < sentences.length; i++) {
    const sentence = sentences[i];
    current.push(sentence);
    const next = sentences[i + 1];
    if (!next || next.start - sentence.end > 1) {
      paragraphs.push(current);
      current = [];
    }
  }

  return (
    <article className="mx-auto w-full max-w-3xl px-6 pb-48 pt-12">
      <h1 className="font-display mb-10 text-balance text-5xl leading-tight tracking-tight text-gradient">
        {title}
      </h1>
      <div className="space-y-6 text-[1.075rem] leading-[1.85] text-foreground/90">
        {paragraphs.map((paragraph, index) => (
          <p key={index}>
            {paragraph.map((sentence) => {
              const active = sentence.id === activeIndex;
              return (
                <span
                  key={sentence.id}
                  ref={active ? activeRef : undefined}
                  onClick={() => onSeek(sentence.id)}
                  className={cn("sentence hover:sentence-hover", active && "sentence-active")}
                >
                  {sentence.text}{" "}
                </span>
              );
            })}
          </p>
        ))}
      </div>
    </article>
  );
}
